import { render } from "./PlaqueReports.vue?vue&type=template&id=06aaaa62&scoped=true&ts=true"
import script from "./PlaqueReports.vue?vue&type=script&lang=ts"
export * from "./PlaqueReports.vue?vue&type=script&lang=ts"

import "./PlaqueReports.vue?vue&type=style&index=0&id=06aaaa62&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06aaaa62"]])

export default __exports__